import request from 'sb-request'
import { getState, reducers } from 'redux/core'
import { constants, array, mixpanel, links } from 'common/helpers'


const neonHeatCollection = 'neon-heat'

const getRandomNumber = (maxNumber) => Math.floor(Math.random() * maxNumber)

const fetchProducts = () => (
  request.post('graphql?name=fetchIncubatorProducts', {
    withErrorModal: false,
    body: {
      query: `{
        incubatorProductRating(collection: "${neonHeatCollection}") {
          productId
          rating
          items {
            itemId
            color
            colorType
          }
          isTopProduct
        }
      }`,
    },
  })
    .then(({ incubatorProductRating }) => incubatorProductRating)
    .then(
      (products) => {
        if (products && products.length) {
          reducers.view.incubatorPage.setProducts(products)
          reducers.view.incubatorPage.setFetching(false)
        }
        else {
          return setProducts()
        }
      },
      () => setProducts()
    )
)

const setProducts = () => {
  const { view: { incubatorPage: { colors } } } = getState()

  const products = array.shuffle(array.range(1, 6)).map((count) => {
    const productColors = colors.find(({ id }) => id === count).colors
    const hasTwoItems   = count < 3
    const items         = []

    array.range(1, hasTwoItems ? 2 : 1).forEach((count, index) => {
      const colorsArray = index
        ? productColors.filter((color) => color !== items[index - 1].color)
        : productColors

      const randomColor = colorsArray[getRandomNumber(colorsArray.length - index)]

      items[index] = {
        itemId: count,
        color: randomColor,
        colorType: 'selectedByDefault',
      }
    })

    return {
      productId: count,
      rating: null,
      items,
      isTopProduct: false,
    }
  })

  const productsInput = products.map(({ productId, rating, items }) => `{
    productId: ${productId},
    isTopProduct: false,
    rating: ${rating},
    items: [
      ${items.map(({ itemId, color, colorType }) => `{
        itemId: ${itemId},
        color: "${color}",
        colorType: "${colorType}"
      }`).join(',')}
    ]
  }`).join(',')

  return request.post('graphql?name=setIncubatorProducts', {
    body: {
      query: `
        mutation {
          saveIncubatorProductRating(collection: "${neonHeatCollection}", input: [${productsInput}]) {
            productId
            rating
            items {
              itemId
              color
              colorType
            }
            isTopProduct
          }
        }
      `,
    },
  })
    .then(({ saveIncubatorProductRating: products }) => {
      reducers.view.incubatorPage.setProducts(products)
      reducers.view.incubatorPage.setFetching(false)
    })
}

const setProductRating = ({ productId, rating }) => {
  const { view: { incubatorPage: { products } } } = getState()

  const productToUpdate = products.find((product) => product.productId === productId)

  return request.post('graphql?name=setIncubatorProduct', {
    body: {
      query: `
        mutation {
          saveIncubatorProductRating(collection: "${neonHeatCollection}", input: {
            productId: ${productId},
            isTopProduct: ${productToUpdate.isTopProduct},
            rating: ${rating},
            items: [
              ${productToUpdate.items.map(({ itemId, color, colorType }) => `{
                itemId: ${itemId},
                color: "${color}",
                colorType: "${colorType}"
              }`).join(',')}
            ]
          }) {
            productId
            rating
            items {
              itemId
              color
              colorType
            }
            isTopProduct
          }
        }
      `,
    },
  })
    .then(({ saveIncubatorProductRating: products }) => reducers.view.incubatorPage.setProducts(products))
}

const setProductItemColor = ({ productId, itemId, color }) => {
  const { view: { incubatorPage: { products } } } = getState()

  const productToUpdate = products.find((product) => product.productId === productId)

  return request.post('graphql?name=setIncubatorProduct', {
    body: {
      query: `
        mutation {
          saveIncubatorProductRating(collection: "${neonHeatCollection}", input: {
            productId: ${productId},
            isTopProduct: ${productToUpdate.isTopProduct},
            rating: ${productToUpdate.rating},
            items: [
              ${productToUpdate.items.map((product) => `{
                itemId: ${product.itemId},
                color: "${product.itemId === itemId ? color : product.color}",
                colorType: "${product.itemId === itemId ? 'selectedByUser' : product.colorType}"
              }`).join(',')}
            ]
          }) {
            productId
            rating
            items {
              itemId
              color
              colorType
            }
            isTopProduct
          }
        }
      `,
    },
  })
    .then(({ saveIncubatorProductRating: products }) => reducers.view.incubatorPage.setProducts(products))
}

const setTopProduct = ({ productId, isTopProduct }) => {
  const { view: { incubatorPage: { products } } } = getState()

  const productToUpdate = products.find((product) => product.productId === productId)

  return request.post('graphql?name=setIncubatorProduct', {
    body: {
      query: `
        mutation {
          saveIncubatorProductRating(collection: "${neonHeatCollection}", input: {
            productId: ${productId},
            isTopProduct: ${isTopProduct},
            rating: ${productToUpdate.rating},
            items: [
              ${productToUpdate.items.map(({ itemId, color, colorType }) => `{
                itemId: ${itemId},
                color: "${color}",
                colorType: "${colorType}"
              }`).join(',')}
            ]
          }) {
            productId
            rating
            items {
              itemId
              color
              colorType
            }
            isTopProduct
          }
        }
      `,
    },
  })
    .then(({ saveIncubatorProductRating: products }) => reducers.view.incubatorPage.setProducts(products))
}

const fetchReviews = () => {
  const {
    view: {
      incubatorPage: { reviewsData: { paginationCursor, sortBy, selectedRating } },
    },
    routing: {
      location: { pathname },
    },
  } = getState()

  const collection = pathname.replace(/\/incubator\//, '')

  reducers.view.incubatorPage.setReviewsFetching(true)

  return request.get(`rest/incubator/${collection}/reviews`, {
    query: {
      start: paginationCursor,
      count: 20,
      sortBy,
      filterByRating: selectedRating,
    },
  })
    .then((result) => {
      reducers.view.incubatorPage.setReviews(result)

      return result
    })
}

const voteForReview = ({ reviewId, replyId, isUseful }) => {
  const { routing: { location: { pathname } } } = getState()

  const collection  = pathname.replace(/\/incubator\//, '')
  const baseUrl     = `rest/incubator/${collection}/reviews/${reviewId}`
  const url         = replyId ? `${baseUrl}/replies/${replyId}/rate` : `${baseUrl}/rate`

  reducers.view.incubatorPage.setReviewVoteFor({ reviewId, replyId, isUseful })

  request.post(url, {
    body: {
      isUseful,
    },
    withErrorModal: false,
  })
}

const setPaginationCursor = (paginationCursor) => {
  reducers.view.incubatorPage.setPaginationCursor(paginationCursor)

  return fetchReviews()
}

const setSelectedRating = (selectedRating) => {
  reducers.view.incubatorPage.setSelectedRating(selectedRating)
  setPaginationCursor(0)
}

const sendReply = (reviewId, message) => {
  const { routing: { location: { pathname } } } = getState()

  const collection = pathname.replace(/\/incubator\//, '')

  request.post(`rest/incubator/${collection}/reviews/${reviewId}/replies`, {
    body: {
      message,
    },
  })
    .then(() => fetchReviews())
}

/**
 * Add new review
 *
 * @param {Object} values
 * @param {String} values.text
 * @param {Number} values.rating
 * @param {Boolean} values.notify
 */
const sendReview = ({ text, rating, notify, userAge }) => {
  const {
    routing: { location: { pathname } },
    view: {
      incubatorPage: { products },
    },
  } = getState()

  const selectedAge       = userAge || 'Prefer not to answer'
  const collection        = pathname.replace(/\/incubator\//, '')
  const isNeonConceptPage = pathname === links.incubator.neonHeat

  if (isNeonConceptPage) {
    const top3ProductsNames = []
    const productData       = {}

    products.forEach(({ productId, rating, items, isTopProduct }) => {
      const productName = ({
        1: 'liner',
        2: 'shadow stick',
        3: 'lip stick',
        4: 'macara',
        5: 'powder blush',
        6: 'lip liner',
      })[productId]

      if (isTopProduct) {
        top3ProductsNames.push(productName)
      }

      if (productId === 1) {
        productData.linerColor1       = items[0].color
        productData.linerColor2       = items[1].color
        productData.linerRating       = rating
      }
      if (productId === 2) {
        productData.shadowStickColor1 = items[0].color
        productData.shadowStickColor2 = items[1].color
        productData.shadowStickRating = rating
      }
      if (productId === 3) {
        productData.lipstickColor     = items[0].color
        productData.lipstickRating    = rating
      }
      if (productId === 4) {
        productData.mascaraColor      = items[0].color
        productData.mascaraRating     = rating
      }
      if (productId === 5) {
        productData.powderBlushColor  = items[0].color
        productData.powderBlushRating = rating
      }
      if (productId === 6) {
        productData.lipLinerColor     = items[0].color
        productData.lipLinerRating    = rating
      }
    })

    mixpanel.track(constants.analyticsEvents.incubatorSubmitReview, {
      'Liner colour Value': productData.linerColor1,
      'Pencil colour Value': productData.linerColor2,
      'Liner rating Value': productData.linerRating,

      'Shadow stick colour 1 Value': productData.shadowStickColor1,
      'Shadow stick colour 2 Value': productData.shadowStickColor2,
      'Shadow stick rating Value': productData.shadowStickRating,

      'Lipstick colour': productData.lipstickColor,
      'Lipstick colour rating Value': productData.lipstickRating,

      'Mascara colour': productData.mascaraColor,
      'Mascara colour rating Value': productData.mascaraRating,

      'Powder blush colour': productData.powderBlushColor,
      'Powder blush rating Value': productData.powderBlushRating,

      'Lip liner colour: Value': productData.lipLinerColor,
      'Lip liner blush rating Value': productData.lipLinerRating,

      '3 best products': top3ProductsNames.join(', '),
      'Concept rating': rating,
      'Age': selectedAge,
      'Notification': notify,
    })
  }
  else {
    mixpanel.track(constants.analyticsEvents.submitReview, {
      concept: 'neon heat kit',
      rating,
    })
  }

  return request.post(`rest/incubator/${collection}/reviews`, {
    body: {
      text,
      rating,
      notify,
      userAge: selectedAge,
    },
  })
    .then(() => fetchReviews())
}

/**
 * Add new review
 *
 * @param {Object} values
 * @param {Object} values.review
 * @param {Number} values.reviewId
 */
const editReview = ({ review, reviewId }) => {
  const { routing: { location: { pathname } } } = getState()

  const collection  = pathname.replace(/\/incubator\//, '')

  return request.post(`rest/incubator/${collection}/reviews/${reviewId}`, {
    body: review,
    formData: true,
  })
}


export default {
  fetchProducts,
  setProductRating,
  setProductItemColor,
  setTopProduct,
  fetchReviews,
  voteForReview,
  setPaginationCursor,
  setSelectedRating,
  sendReply,
  sendReview,
  editReview,
}
